angular.
module("dx.webapp.session").
factory("dxSession", function sessionService(
	$cookies,
	$document,
	$window,

	DxUser,
	RoleTypeEnum,
	Role,
	dxKayako,
	dxRegion,
	dxLocalize,
	dxUserSettings,

	Raven
) {
	"use strict";

	var role = new Role();
	var user = new DxUser();
	var availableRoles = [];
	var loginOrigin = "";
	var kayakoAuthData = null;
	var intercomAuthData = null;

	var MOST_RECENT_ROLE_KEY = "recentRole";

	function setSessionData(newUser, roles, intercom) {
		loginOrigin = $cookies.get("loginOrigin");
		setUser(newUser);
		dxUserSettings.initializeSettings(newUser.id);
		setAvailableRoles(roles);

		// Set the current region as selected if the user has a valid session
		// This makes accepting an invite etc an implicit selection by the user
		dxRegion.setSelected(dxRegion.getCurrent());

		intercomAuthData = intercom;
	}

	function setUser(newUser) {
		if (typeof newUser === "object") {
			user = newUser;
		} else {
			user = new DxUser();
		}

		if (user && user.id > 0) {
			Raven.setUserContext({
				id: user.id,
			});
		}
	}

	function getUser() {
		return user;
	}

	function getIntercom() {
		return intercomAuthData;
	}

	function setRole(newRole) {
		role = new Role(newRole);

		// Set recentRole cookie expiration date to 30 days from today.
		var expires = new Date();
		expires.setDate(expires.getDate() + 30);

		$cookies.put(MOST_RECENT_ROLE_KEY, role.id, {path: "/", expires: expires});

		writeRoleCookie(role.roleKey);

		Raven.setUserContext({
			id: user.id,
			organizationId: role.organizationId,
		});

		setVisibilityOfKayakoChat();
	}

	// AngularJS 1.6.10 does not support the SameSite attribute so we have to write the
	// cookie manually.
	function writeRoleCookie(roleKey) {
		var val = "role=" + encodeURIComponent(roleKey);
		val += ";path=/";

		if ($window.location.protocol === "https:") {
			val += ";secure";

			if (loginOrigin === "lti") {
				val += ";samesite=none";
			}
		}

		$document[0].cookie = val;
	}

	function getRole() {
		return role;
	}

	function setAvailableRoles(roles) {
		availableRoles = roles.sort(function compareAlphabetically(a, b) {
			var res = a.displayName.localeCompare(b.displayName);

			if (a.roleType === RoleTypeEnum.STUDENT) {
				res = 1;
			}
			if (b.roleType === RoleTypeEnum.STUDENT) {
				res = -1;
			}
			return res;
		});

		var recentRole = getRecentRole();
		if (recentRole !== null) {
			setRole(recentRole);
			return;
		}

		var highestRole = null;
		for (var i = 0; i < roles.length; i++) {
			if (!highestRole || highestRole.roleType < roles[i].roleType) {
				highestRole = roles[i];
			}
		}

		setRole(highestRole);
	}

	function getAvailableRoles() {
		for (var i = 0; i < availableRoles.length; i++) {
			if (availableRoles[i].roleType === RoleTypeEnum.INVIGILATOR) {
				availableRoles[i].displayName = availableRoles[i].displayName.substring(0, availableRoles[i].displayName.indexOf("- ") + 2) + dxLocalize.get("RoleType_32");
			}

			if (availableRoles[i].integrationSource === 3 && availableRoles[i].roleType === RoleTypeEnum.TEACHER) {
				availableRoles[i].displayName = availableRoles[i].displayName.substring(0, availableRoles[i].displayName.indexOf("- ") + 2) + dxLocalize.get("RoleType_2");
			}
		}

		return availableRoles;
	}

	function getRecentRole() {
		var recentRole = $cookies.get(MOST_RECENT_ROLE_KEY);
		if (recentRole) {
			for (var i = 0; i < availableRoles.length; i++) {
				if (availableRoles[i].id.toString() === recentRole) {
					return availableRoles[i];
				}
			}
		}

		return null;
	}

	function isAuthenticated() {
		return role.roleType > RoleTypeEnum.PUB && user.id > 0;
	}

	function isSkolonUser() {
		return loginOrigin === "skolon";
	}

	function restore() {
		var data = $window.DX.restoredSessionData;
		if (data.isSessionValid) {
			setSessionData(new DxUser(data.user), data.organizationRoles, data.intercom);
		} else {
			dxKayako.hide();
		}
	}

	function destroySession() {
		dxKayako.logout();

		dxKayako.hide();
		Raven.setUserContext();

		$cookies.remove("user");
		$cookies.remove("role");
		$cookies.remove("csrf");
		$cookies.remove("impersonator");
		$cookies.remove("loginOrigin");

		user = new DxUser();
		role = new Role();
		availableRoles = [];
	}

	function setVisibilityOfKayakoChat() {
		if (kayakoAuthData && isAuthenticated() && getRole().roleType !== RoleTypeEnum.STUDENT) {
			dxKayako.show();
		} else {
			dxKayako.hide();
		}
	}

	return {
		setSessionData: setSessionData,
		getUser: getUser,
		setRole: setRole,
		getRole: getRole,
		getAvailableRoles: getAvailableRoles,
		isAuthenticated: isAuthenticated,
		isSkolonUser: isSkolonUser,
		restore: restore,
		destroySession: destroySession,
		getIntercom: getIntercom,
	};
});
